import { render } from "./App.vue?vue&type=template&id=7c1101b2"
const script = {}

import "./App.vue?vue&type=style&index=0&id=7c1101b2&lang=scss"

import exportComponent from "C:\\Users\\17630037586\\Desktop\\新建文件夹 (2)\\新建文件夹\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__